export const paymentStatus = {
  NOT_PAID: 'Not Paid',
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  REFUNDED: 'Refunded',
  CANCELED: 'Canceled',
  PAID: 'Paid',
};

export type PaymentStatusType =
  (typeof paymentStatus)[keyof typeof paymentStatus];
export type PaymentStatusKey = keyof typeof paymentStatus;
